export function updateFilter(filter) {
    return { type: 'UPDATE_FILTER', filtro: filter };
}

export function cleanFilter() {
    return { type: 'CLEAN_FILTER' };
}


// WEBPACK FOOTER //
// ./src/redux/actions/filtroAction.js